// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text_input {
    width: 100%;
    padding: 8px 11px;
    background-color: var(--color-bg-3);
    border: 1px solid var(--color-border);
    border-radius: 4px;
    color: var(--color-text);
    font-size: 14px;
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.1s;
    font-family: inherit;
    resize: none;
}

.text_input:focus {
    border-color: var(--color-accent);
}

.text_input::placeholder {
    color: var(--color-text-muted);
}

.text_input--textarea {
    min-height: 79px;
    line-height: 1.5;
}

/* Applied on mobile while the virtual keyboard is open */
.text_input--vkb-active {
    border-color: var(--color-accent);
}

/* Hidden input used as focus target on mobile to suppress the native keyboard */
.text_input__hidden_input {
    position: fixed;
    top: -200px;
    left: -200px;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
    font-size: 16px;
}

/* Wrapper that positions the cursor overlay on top of the real input */
.text_input__touch_wrapper {
    position: relative;
    width: 100%;
}

.text_input__touch_wrapper--textarea {
    display: flex;
}


/* Cursor overlay — mirrors the input's visual area, rendered by CursorDisplay */
.text_input__cursor_overlay {
    position: absolute;
    inset: 0;
    padding: 8px 11px;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;
    align-items: center;
    user-select: none;
    scrollbar-width: none;
    box-sizing: border-box;
}

.text_input__cursor_overlay::-webkit-scrollbar {
    display: none;
}

/* Multiline textarea variant */
.text_input__cursor_overlay--multiline {
    white-space: pre-wrap;
    overflow-x: hidden;
    overflow-y: hidden;
    align-items: flex-start;
    flex-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/TextInput/s.text_input.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,iCAAiC;AACrC;;AAEA,gFAAgF;AAChF;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,eAAe;AACnB;;AAEA,uEAAuE;AACvE;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;;AAGA,gFAAgF;AAChF;IACI,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA,+BAA+B;AAC/B;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB","sourcesContent":[".text_input {\n    width: 100%;\n    padding: 8px 11px;\n    background-color: var(--color-bg-3);\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    color: var(--color-text);\n    font-size: 14px;\n    outline: none;\n    box-sizing: border-box;\n    transition: border-color 0.1s;\n    font-family: inherit;\n    resize: none;\n}\n\n.text_input:focus {\n    border-color: var(--color-accent);\n}\n\n.text_input::placeholder {\n    color: var(--color-text-muted);\n}\n\n.text_input--textarea {\n    min-height: 79px;\n    line-height: 1.5;\n}\n\n/* Applied on mobile while the virtual keyboard is open */\n.text_input--vkb-active {\n    border-color: var(--color-accent);\n}\n\n/* Hidden input used as focus target on mobile to suppress the native keyboard */\n.text_input__hidden_input {\n    position: fixed;\n    top: -200px;\n    left: -200px;\n    width: 1px;\n    height: 1px;\n    opacity: 0;\n    pointer-events: none;\n    font-size: 16px;\n}\n\n/* Wrapper that positions the cursor overlay on top of the real input */\n.text_input__touch_wrapper {\n    position: relative;\n    width: 100%;\n}\n\n.text_input__touch_wrapper--textarea {\n    display: flex;\n}\n\n\n/* Cursor overlay — mirrors the input's visual area, rendered by CursorDisplay */\n.text_input__cursor_overlay {\n    position: absolute;\n    inset: 0;\n    padding: 8px 11px;\n    font-size: inherit;\n    font-family: inherit;\n    line-height: inherit;\n    overflow-x: scroll;\n    overflow-y: hidden;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    user-select: none;\n    scrollbar-width: none;\n    box-sizing: border-box;\n}\n\n.text_input__cursor_overlay::-webkit-scrollbar {\n    display: none;\n}\n\n/* Multiline textarea variant */\n.text_input__cursor_overlay--multiline {\n    white-space: pre-wrap;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
